"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const numericInput_1 = __importDefault(require("../../../numericInput"));
class NumericInputWidget extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.handleFocus = ({ target: { value } }) => {
            this.props.onFocus(this.props.id, value);
        };
        this.handleBlur = ({ target: { value } }) => {
            this.props.onBlur(this.props.id, value);
        };
        this.handleChange = (value) => {
            this.props.onChange(value !== null ? value : '');
        };
    }
    render() {
        const { id, placeholder, value, disabled, readonly: readOnly, autofocus: autoFocus } = this.props;
        const numericInputProps = {
            id,
            placeholder,
            value,
            disabled,
            readOnly,
            autoFocus,
            onChange: this.handleChange,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus
        };
        return jsx_runtime_1.jsx(numericInput_1.default, Object.assign({}, numericInputProps), void 0);
    }
}
NumericInputWidget.defaultProps = {
    value: '',
    placeholder: '',
    required: false,
    disabled: false,
    readonly: false,
    autofocus: false,
    onChange: () => { },
    onBlur: () => { },
    onFocus: () => { }
};
exports.default = NumericInputWidget;
//# sourceMappingURL=numericWidget.js.map